import { Dispatch } from '@reduxjs/toolkit';
import { keyBy } from 'lodash/fp';

import { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ReportIssueType } from 'dashboard/lib/constants/reportIssue';
import { DocumentGeneric } from 'dashboard/models/document';
import { Tag } from 'dashboard/models/tag';
import { User } from 'dashboard/models/user';
import { Verification, VerificationCore } from 'dashboard/models/verification';
import { setVerification, setVerificationDetails } from 'dashboard/redux/actions/verification';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadVerification(id: string) {
  return async (dispatch: Dispatch) => {
    const verificationResponse = await SessionClientDashboard.getResource<Verification>(
      ApiEndpoint.Verification,
      id,
    );
    const verification = verificationResponse.data;

    const relationshipMap = keyBy('id', verificationResponse.included);

    const document =
      verification.relationships.document?.data != null
        ? (relationshipMap[verification.relationships.document.data.id] as DocumentGeneric)
        : undefined;

    const tags = verification.relationships.tags?.data.map(
      ({ id }) => relationshipMap[id],
    ) as Tag[];

    const redactor =
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      verification.relationships.redactor.data != null
        ? /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          (relationshipMap[verification.relationships.redactor.data.id] as User)
        : undefined;

    // Dispatch details before verification so we can safely use presence of verification
    // to indicate that all data are fetched
    dispatch(
      setVerificationDetails({
        redactor,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        document,
        tags,
      }),
    );
    dispatch(setVerification(verification));
  };
}

export const redactVerification = (id: string) => {
  return async () => {
    await SessionClientDashboard.deleteResource<Verification>(ApiEndpoint.Verification, id);
  };
};

export const flagVerification = (
  verification: Verification,
  {
    issueVerifications,
    issueType,
    fraudType,
    content,
    responseType,
    addAsFraudulent,
  }: FlagIssuesFormData,
) => {
  return async () => {
    let addAsFraudulentText = 'none';

    let groundTruth = {} as any;
    switch (issueType) {
      case ReportIssueType.Classification:
        groundTruth = issueVerifications.at(-1)?.correctValue;
        break;
      case ReportIssueType.Extraction: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        issueVerifications.map((issue) => (groundTruth[issue.attributeName] = issue.correctValue));
        break;
      }
      case ReportIssueType.Fraud:
        addAsFraudulentText = addAsFraudulent ? 'fraud' : 'none';
        groundTruth = { status: 'failed' };
        break;
    }

    await SessionClientDashboard.postResourceAction<VerificationCore>(
      { id: verification.id, type: ApiModel.Verification },
      'flag-issues',
      {
        meta: {
          'issue-type': issueType,
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          'fraud-type': fraudType,
          'ground-truth': groundTruth,
          description: content,
          'response-type': responseType,
          'add-to-global-registry': addAsFraudulentText,
        },
      },
    );
  };
};
